import React, { Component } from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    Grid,
    TextField,
    MenuItem,
    Button,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Divider,
    Stack,
    Collapse,
    Tooltip
} from '@mui/material';
import LayersIcon from '@mui/icons-material/Layers';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import ArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const inputStyle = {
    '& .MuiOutlinedInput-root': {
        borderRadius: 2,
        backgroundColor: '#fff',
        '&:hover fieldset': { borderColor: '#cbd5e1' },
        '&.Mui-focused fieldset': { borderColor: '#7c3aed' },
    }
};

export default class GerenciadorVariacoes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expandidoSecao: false,

            // ID da variação que está sendo editada (null se for criação)
            idVariacaoEmEdicao: null,

            // Configurações da variação principal
            tipoVariacao: 'cor',
            nomePersonalizado: '',
            minimoEscolhas: 0,
            maximoEscolhas: 1,

            // Inputs do item temporário sendo cadastrado/editado
            idItemEmEdicao: null,
            valorItem: '',
            corHex: '#7c3aed',
            precoItem: 0,
            estoqueItem: '',

            // Lista temporária dos sub-itens da variação atual
            itensTemporarios: []
        };
    }

    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    };

    getNomeVariacaoAtual = () => {
        const { tipoVariacao, nomePersonalizado } = this.state;
        if (tipoVariacao === 'cor') return 'Cor';
        if (tipoVariacao === 'tamanho') return 'Tamanho';
        return nomePersonalizado || 'Variação Customizada';
    };

    // Adiciona um novo sub-item ou atualiza o item em edição
    handleSalvarItemTemporario = () => {
        const { valorItem, corHex, precoItem, estoqueItem, tipoVariacao, itensTemporarios, idItemEmEdicao } = this.state;

        if (!valorItem && tipoVariacao !== 'cor') return;

        if (idItemEmEdicao) {
            // Edição de sub-item
            const itensAtualizados = itensTemporarios.map(item => {
                if (item.id === idItemEmEdicao) {
                    return {
                        ...item,
                        nome: tipoVariacao === 'cor' ? (valorItem || 'Cor') : valorItem,
                        hex: tipoVariacao === 'cor' ? corHex : null,
                        preco: parseFloat(precoItem) || 0,
                        estoque: parseInt(estoqueItem) || 0
                    };
                }
                return item;
            });

            this.setState({
                itensTemporarios: itensAtualizados,
                idItemEmEdicao: null,
                valorItem: '',
                precoItem: 0,
                estoqueItem: ''
            });
        } else {
            // Adição de novo sub-item
            const novoItem = {
                id: Date.now(),
                nome: tipoVariacao === 'cor' ? (valorItem || 'Cor Nova') : valorItem,
                hex: tipoVariacao === 'cor' ? corHex : null,
                preco: parseFloat(precoItem) || 0,
                estoque: parseInt(estoqueItem) || 0
            };

            this.setState({
                itensTemporarios: [...itensTemporarios, novoItem],
                valorItem: '',
                precoItem: 0,
                estoqueItem: ''
            });
        }
    };

    // Carrega sub-item nos campos para edição
    handleCarregarItemParaEdicao = (item) => {
        this.setState({
            idItemEmEdicao: item.id,
            valorItem: item.nome,
            corHex: item.hex || '#7c3aed',
            precoItem: item.preco,
            estoqueItem: item.estoque
        });
    };

    // Cancelar edição do sub-item
    handleCancelarEdicaoItem = () => {
        this.setState({
            idItemEmEdicao: null,
            valorItem: '',
            precoItem: 0,
            estoqueItem: ''
        });
    };

    // Remove sub-item da tabela temporária
    handleRemoverItemTemporario = (id) => {
        this.setState({
            itensTemporarios: this.state.itensTemporarios.filter(item => item.id !== id),
            ...(this.state.idItemEmEdicao === id ? { idItemEmEdicao: null, valorItem: '', precoItem: 0, estoqueItem: '' } : {})
        });
    };

    // Carrega uma variação inteira salva previamente para o formulário de edição
    handleEditarVariacaoDoProduto = (variacao) => {
        this.setState({
            expandidoSecao: true,
            idVariacaoEmEdicao: variacao.id,
            tipoVariacao: variacao.tipo,
            nomePersonalizado: (variacao.tipo === 'personalizado') ? variacao.nome : '',
            minimoEscolhas: variacao.minimoEscolhas ?? 0,
            maximoEscolhas: variacao.maximoEscolhas ?? 1,
            itensTemporarios: [...variacao.itens],
            idItemEmEdicao: null,
            valorItem: '',
            precoItem: 0,
            estoqueItem: ''
        });
    };

    // Reseta o formulário
    handleLimparFormulario = () => {
        this.setState({
            idVariacaoEmEdicao: null,
            tipoVariacao: 'cor',
            nomePersonalizado: '',
            minimoEscolhas: 0,
            maximoEscolhas: 1,
            idItemEmEdicao: null,
            valorItem: '',
            corHex: '#7c3aed',
            precoItem: 0,
            estoqueItem: '',
            itensTemporarios: []
        });
    };

    // Salva ou atualiza a variação na lista global
    handleSalvarVariacaoNoProduto = () => {
        const {
            idVariacaoEmEdicao,
            itensTemporarios,
            tipoVariacao,
            minimoEscolhas,
            maximoEscolhas
        } = this.state;

        const listaAtual = this.props.listaDeVariacoes || [];

        if (itensTemporarios.length === 0) return;

        const dadosVariacao = {
            id: idVariacaoEmEdicao || Date.now(),
            tipo: tipoVariacao,
            nome: this.getNomeVariacaoAtual(),
            minimoEscolhas: parseInt(minimoEscolhas) || 0,
            maximoEscolhas: parseInt(maximoEscolhas) || 0,
            itens: itensTemporarios
        };

        let novaLista = [];

        if (idVariacaoEmEdicao) {
            // Atualizando variação existente
            novaLista = listaAtual.map(v => v.id === idVariacaoEmEdicao ? dadosVariacao : v);
        } else {
            // Adicionando nova variação
            novaLista = [...listaAtual, dadosVariacao];
        }

        this.handleLimparFormulario();

        if (typeof this.props.onVariacoesChange === 'function') {
            this.props.onVariacoesChange(novaLista);
        }
    };

    handleRemoverVariacaoDoProduto = (id) => {
        const listaAtual = this.props.listaDeVariacoes || [];
        const novaLista = listaAtual.filter(v => v.id !== id);

        if (this.state.idVariacaoEmEdicao === id) {
            this.handleLimparFormulario();
        }

        if (typeof this.props.onVariacoesChange === 'function') {
            this.props.onVariacoesChange(novaLista);
        }
    };

    render() {
        const {
            expandidoSecao,
            idVariacaoEmEdicao,
            tipoVariacao,
            nomePersonalizado,
            minimoEscolhas,
            maximoEscolhas,
            idItemEmEdicao,
            valorItem,
            corHex,
            precoItem,
            estoqueItem,
            itensTemporarios
        } = this.state;

        const listaDeVariacoes = this.props.listaDeVariacoes || [];

        return (
            <Box sx={{ margin: 'auto', p: 0 }}>
                <Card sx={{ mt: 3, borderRadius: 3, boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.04)', border: '1px solid #e2e8f0' }}>
                    <CardContent sx={{ p: 3 }}>

                        {/* Cabeçalho do Card */}
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                <Box sx={{ bgcolor: '#f3e8ff', p: 1, borderRadius: 2, display: 'flex' }}>
                                    <LayersIcon sx={{ color: '#7c3aed' }} />
                                </Box>
                                <Box>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1e293b' }}>
                                        {idVariacaoEmEdicao ? "Editando Variação" : "Atributos & Variações"}
                                    </Typography>
                                    <Typography variant="caption" color="textSecondary">
                                        Configure tamanhos, cores, limites de seleção e opções do produto
                                    </Typography>
                                </Box>
                            </Box>

                            <Button
                                onClick={() => this.setState({ expandidoSecao: !expandidoSecao })}
                                startIcon={expandidoSecao ? <ArrowUpIcon fontSize="small" /> : <ArrowDownIcon fontSize="small" />}
                                sx={{ textTransform: 'none', color: '#64748b', fontWeight: '500' }}
                            >
                                {expandidoSecao ? "Recolher" : "Configurar"}
                            </Button>
                        </Box>

                        <Collapse in={expandidoSecao}>
                            {/* Linha 1: Tipo e Nome da Variação */}
                            <Grid container spacing={2} sx={{ mb: 2 }}>
                                <Grid item xs={12} sm={tipoVariacao === 'personalizado' ? 4 : 12}>
                                    <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                        Tipo da variação <span style={{ color: '#ef4444' }}>*</span>
                                    </Typography>
                                    <TextField
                                        select
                                        fullWidth
                                        name="tipoVariacao"
                                        value={tipoVariacao}
                                        onChange={(e) => {
                                            this.handleInputChange(e);
                                            this.setState({ itensTemporarios: [], valorItem: '', idItemEmEdicao: null });
                                        }}
                                        variant="outlined"
                                        size="small"
                                        sx={inputStyle}
                                    >
                                        <MenuItem value="cor">Cor</MenuItem>
                                        <MenuItem value="tamanho">Tamanho</MenuItem>
                                        <MenuItem value="personalizado">Personalizado</MenuItem>
                                    </TextField>
                                </Grid>

                                {tipoVariacao === 'personalizado' && (
                                    <Grid item xs={12} sm={8}>
                                        <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                            Nome da variação customizada <span style={{ color: '#ef4444' }}>*</span>
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            name="nomePersonalizado"
                                            value={nomePersonalizado}
                                            onChange={this.handleInputChange}
                                            placeholder="Ex: Voltagem, Adicionais, Sabor"
                                            variant="outlined"
                                            size="small"
                                            sx={inputStyle}
                                        />
                                    </Grid>
                                )}
                            </Grid>

                            {/* Linha 2: Regras de Mínimo e Máximo de Escolhas */}
                            <Grid container spacing={2} sx={{ mb: 3 }}>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                        Mínimo de opções obrigatórias
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        type="number"
                                        name="minimoEscolhas"
                                        value={minimoEscolhas}
                                        onChange={this.handleInputChange}
                                        placeholder="0"
                                        variant="outlined"
                                        size="small"
                                        sx={inputStyle}
                                        helperText="0 = Escolha opcional pelo cliente"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                        Máximo de opções permitidas
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        type="number"
                                        name="maximoEscolhas"
                                        value={maximoEscolhas}
                                        onChange={this.handleInputChange}
                                        placeholder="1"
                                        variant="outlined"
                                        size="small"
                                        sx={inputStyle}
                                        helperText="Ex: 1 para seleção única ou N para limite livre"
                                    />
                                </Grid>
                            </Grid>

                            <Divider sx={{ my: 2.5, borderColor: '#e2e8f0' }} />

                            {/* Linha 3: Formulário do Sub-Item */}
                            <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#475569', mb: 2 }}>
                                {idItemEmEdicao ? "Editando opção da variação" : `Adicionar valores para "${this.getNomeVariacaoAtual()}"`}
                            </Typography>

                            <Grid container spacing={2} alignItems="flex-end" sx={{ mb: 3 }}>
                                <Grid item xs={12} sm={tipoVariacao === 'cor' ? 4 : 5}>
                                    <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                        {tipoVariacao === 'cor' ? "Nome da Cor" : tipoVariacao === 'tamanho' ? "Dimensão / Tamanho" : "Valor / Opção"}
                                    </Typography>

                                    <Stack direction="row" spacing={1} alignItems="center">
                                        {tipoVariacao === 'cor' && (
                                            <input
                                                type="color"
                                                value={corHex}
                                                name="corHex"
                                                onChange={this.handleInputChange}
                                                style={{
                                                    width: 42,
                                                    height: 40,
                                                    border: '1px solid #e2e8f0',
                                                    borderRadius: '8px',
                                                    cursor: 'pointer',
                                                    padding: 0,
                                                    backgroundColor: 'transparent'
                                                }}
                                            />
                                        )}
                                        <TextField
                                            fullWidth
                                            name="valorItem"
                                            value={valorItem}
                                            onChange={this.handleInputChange}
                                            placeholder={tipoVariacao === 'cor' ? "Ex: Azul Marinho" : tipoVariacao === 'tamanho' ? "Ex: G, 42, P" : "Ex: 220V, Bacon Extra"}
                                            variant="outlined"
                                            size="small"
                                            sx={inputStyle}
                                        />
                                    </Stack>
                                </Grid>

                                <Grid item xs={12} sm={3}>
                                    <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                        Preço adicional
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        name="precoItem"
                                        value={precoItem ? new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(precoItem) : ""}
                                        onChange={(event) => {
                                            const rawValue = event.target.value;
                                            const cleanValue = rawValue.replace(/\D/g, "");
                                            const numberValue = cleanValue ? parseFloat(cleanValue) / 100 : 0;
                                            this.setState({ precoItem: numberValue });
                                        }}
                                        placeholder="R$ 0,00"
                                        variant="outlined"
                                        size="small"
                                        sx={inputStyle}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={2}>
                                    <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                        Estoque
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        type="number"
                                        name="estoqueItem"
                                        value={estoqueItem}
                                        onChange={this.handleInputChange}
                                        placeholder="0"
                                        variant="outlined"
                                        size="small"
                                        sx={inputStyle}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={2}>
                                    <Stack direction="row" spacing={1}>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            onClick={this.handleSalvarItemTemporario}
                                            startIcon={idItemEmEdicao ? <CheckIcon /> : <AddIcon />}
                                            sx={{
                                                height: 40,
                                                borderRadius: 2,
                                                textTransform: 'none',
                                                bgcolor: idItemEmEdicao ? '#059669' : '#7c3aed',
                                                '&:hover': { bgcolor: idItemEmEdicao ? '#047857' : '#6d28d9' }
                                            }}
                                        >
                                            {idItemEmEdicao ? "Atualizar" : "Inserir"}
                                        </Button>
                                        {idItemEmEdicao && (
                                            <IconButton color="default" onClick={this.handleCancelarEdicaoItem} sx={{ border: '1px solid #cbd5e1' }}>
                                                <CloseIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                    </Stack>
                                </Grid>
                            </Grid>

                            {/* Tabela de itens da variação */}
                            {itensTemporarios.length > 0 && (
                                <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 2, borderColor: '#e2e8f0', mb: 3 }}>
                                    <Table size="small">
                                        <TableHead sx={{ backgroundColor: '#f8fafc' }}>
                                            <TableRow>
                                                <TableCell sx={{ fontWeight: '600', color: '#64748b' }}>Item / Propriedade</TableCell>
                                                <TableCell align="right" sx={{ fontWeight: '600', color: '#64748b' }}>Acréscimo</TableCell>
                                                <TableCell align="right" sx={{ fontWeight: '600', color: '#64748b' }}>Qtd. Estoque</TableCell>
                                                <TableCell align="center" sx={{ fontWeight: '600', color: '#64748b' }}>Ações</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {itensTemporarios.map((item) => (
                                                <TableRow key={item.id} hover selected={item.id === idItemEmEdicao}>
                                                    <TableCell sx={{ display: 'flex', alignItems: 'center', gap: 1.5, color: '#1e293b' }}>
                                                        {item.hex && (
                                                            <Box sx={{ width: 16, height: 16, borderRadius: '50%', bgcolor: item.hex, border: '1px solid #cbd5e1' }} />
                                                        )}
                                                        {item.nome}
                                                    </TableCell>
                                                    <TableCell align="right" sx={{ fontWeight: '500', color: '#1e293b' }}>
                                                        {new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(item.preco)}
                                                    </TableCell>
                                                    <TableCell align="right" sx={{ color: '#475569' }}>{item.estoque}</TableCell>
                                                    <TableCell align="center">
                                                        <Tooltip title="Editar Item">
                                                            <IconButton size="small" color="primary" onClick={() => this.handleCarregarItemParaEdicao(item)}>
                                                                <EditIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title="Remover Item">
                                                            <IconButton size="small" color="error" onClick={() => this.handleRemoverItemTemporario(item.id)}>
                                                                <DeleteIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            )}

                            {/* Ações Finais da Variação */}
                            <Stack direction="row" spacing={2}>
                                <Button
                                    variant="contained"
                                    disabled={itensTemporarios.length === 0}
                                    onClick={this.handleSalvarVariacaoNoProduto}
                                    sx={{
                                        textTransform: 'none',
                                        borderRadius: 2.5,
                                        fontWeight: '600',
                                        bgcolor: '#7c3aed',
                                        '&:hover': { bgcolor: '#6d28d9' }
                                    }}
                                >
                                    {idVariacaoEmEdicao ? "Atualizar Variação no Produto" : "Salvar Variação no Cadastro do Produto"}
                                </Button>

                                {idVariacaoEmEdicao && (
                                    <Button
                                        variant="outlined"
                                        color="inherit"
                                        onClick={this.handleLimparFormulario}
                                        sx={{ textTransform: 'none', borderRadius: 2.5, fontWeight: '600' }}
                                    >
                                        Cancelar Edição
                                    </Button>
                                )}
                            </Stack>
                        </Collapse>
                    </CardContent>
                </Card>

                {/* Exibição das Variações Ativas no Produto */}
                {listaDeVariacoes.length > 0 && (
                    <Box sx={{ mt: 4 }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#475569', mb: 2, px: 0.5 }}>
                            Variações Ativas neste Produto ({listaDeVariacoes.length})
                        </Typography>

                        {listaDeVariacoes.map((variacao) => (
                            <Card
                                key={variacao.id}
                                sx={{
                                    mb: 2,
                                    borderRadius: 3,
                                    border: idVariacaoEmEdicao === variacao.id ? '2px solid #7c3aed' : '1px solid #e2e8f0',
                                    boxShadow: 'none',
                                    bgcolor: '#fff'
                                }}
                            >
                                <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                                        <Stack direction="row" spacing={1} alignItems="center">
                                            <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#7c3aed' }}>
                                                {variacao.nome.toUpperCase()}
                                            </Typography>
                                            <Typography variant="caption" sx={{ bgcolor: '#f1f5f9', px: 1, py: 0.3, borderRadius: 1, color: '#64748b' }}>
                                                Mín: {variacao.minimoEscolhas ?? 0} | Máx: {variacao.maximoEscolhas ?? 1}
                                            </Typography>
                                        </Stack>

                                        <Stack direction="row" spacing={0.5}>
                                            <Tooltip title="Editar Variação Completa">
                                                <IconButton size="small" color="primary" onClick={() => this.handleEditarVariacaoDoProduto(variacao)}>
                                                    <EditIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Excluir Variação">
                                                <IconButton size="small" color="error" onClick={() => this.handleRemoverVariacaoDoProduto(variacao.id)}>
                                                    <DeleteIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        </Stack>
                                    </Box>

                                    {/* Sub-itens salvos */}
                                    <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
                                        {variacao.itens.map((subItem) => (
                                            <Box
                                                key={subItem.id}
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 1,
                                                    bgcolor: '#ffffff',
                                                    border: '1px solid #e2e8f0',
                                                    borderRadius: 2,
                                                    px: 1.5,
                                                    py: 0.75,
                                                    fontSize: '0.815rem',
                                                    boxShadow: '0px 1px 2px rgba(0,0,0,0.02)'
                                                }}
                                            >
                                                {subItem.hex && (
                                                    <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: subItem.hex }} />
                                                )}
                                                <span style={{ fontWeight: '600', color: '#1e293b' }}>{subItem.nome}</span>
                                                <span style={{ color: '#94a3b8' }}>|</span>
                                                <span style={{ color: '#2e7d32', fontWeight: '500' }}>
                                                    +{new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(subItem.preco)}
                                                </span>
                                                <span style={{ color: '#94a3b8' }}>|</span>
                                                <span style={{ color: '#64748b' }}>Qtd: {subItem.estoque}</span>
                                            </Box>
                                        ))}
                                    </Stack>
                                </CardContent>
                            </Card>
                        ))}
                    </Box>
                )}
            </Box>
        );
    }
}